import * as React from "react";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { Numeric } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { Button } from "../../../../../../../react-core/Html/Button";
import { FsaSourcedCompanyDetailModel } from "../../../../../../../Wrap/Models/Models/Company/FsaSourcedCompanyDetailModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import { groupBy, isArray, isNumber } from "lodash";
import { ExternalPensionTransferOnInstructionPersonalRecommendation } from "../../../../../../../Wrap/Models/Domains/Transfer/Pension/ExternalPensionTransferOnInstructionPersonalRecommendation";
import { FsaAuthorisationStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/FsaAuthorisationStatus";

interface IFCAReferenceProps extends IProcessComponentProps {
    data:ExternalPensionTransferOnInstructionPersonalRecommendation,
    isReview?: boolean;
    isAdmin: boolean;
}

interface IFCAReferenceState {
    IsFindCompanyBusy: boolean;
    NoMatchFound: boolean;
    FsaPermissions: any;
    FsaSourcedCompanyDetailModel:FsaSourcedCompanyDetailModel
}

export class FCAReference extends ProcessComponent<IFCAReferenceProps, IFCAReferenceState> {
    constructor(props: any) {
        super(props);
        this.state = {
            IsFindCompanyBusy: false,
            NoMatchFound: null,
            FsaPermissions: null,
            FsaSourcedCompanyDetailModel:null
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        const { FsaAuthorisationNumber } = this.props.data;
        if (Number(FsaAuthorisationNumber) > 0) {
            this.GetSourcedCompanyDetails();
        }
    }
    
    isValid(): boolean {
        let flag = super.isValid();
        if (this.state.NoMatchFound==null)
        { 
            this.props.showErrorMsgPopUp(["Please find FCA/Trading reference"], true);
            flag = false;
        }
        if (this.state.NoMatchFound) {
            this.props.showErrorMsgPopUp(["Can not find a registered company with the FCA reference number"], true);
            flag = false;
        }
        if (!this.props.isAdmin && !(this.state.FsaSourcedCompanyDetailModel?.Status == FsaAuthorisationStatus.Authorised && this.IsPensionTransfersPermissionHeld()))
        {
            this.props.showErrorMsgPopUp(["Unable to process application at this time due to insufficient FCA permissions"], true);
            flag=false;
        }
        return flag;
    }

    SetPermissionToState(permission: Array<FsaPermission>) {
        const activities = groupBy(permission, "FsaRegulatedActivity.FsaRegulatedActivityId");

        Object.keys(activities).map((activity) => {
            const header: FsaPermission = {
                FsaInvestmentType: {
                    FsaInvestmentTypeId: 0,
                    ExternalId: 0,
                    Name: activities[activity][0].FsaRegulatedActivity.Name,
                },
                FsaRegulatedActivity: activities[activity][0].FsaRegulatedActivity,
                IsPermit: activities[activity].some((x) => x.IsPermit || x.IsInclude),
                IsInclude: false,
            };
            activities[activity] = [header].concat(activities[activity]);
        });

        this.setState({ FsaPermissions: activities });
    }

    GetSourcedCompanyDetails() {
        const { FsaAuthorisationNumber } = this.props.data;
        this.setState({ IsFindCompanyBusy: true }, () => {
            CompanyWizardAction.getFsaSourcedCompanyDetail(
                FsaAuthorisationNumber,
                (data: FsaSourcedCompanyDetailModel) => {
                    if (data != null && !CommonHelper.isNullOrEmpty(data?.RegisteredCompanyName)) {
                        this.SetPermissionToState(data.SourcedCompanyPermission);
                        this.setState({
                            FsaSourcedCompanyDetailModel: { Status: data.Status },
                            NoMatchFound: false,
                            IsFindCompanyBusy: false,
                        });
                    }
                    else {
                        this.setState({
                            FsaSourcedCompanyDetailModel:null,
                            NoMatchFound: true,
                            IsFindCompanyBusy: false,
                        });
                    }
                }
            );
        });
    }

    IsPensionTransfersPermissionHeld() {
        let flag=false;
        if (this.state.FsaPermissions) {
            const PensionTransfersFsaRegulatedActivityId = 1; 
            let permission = this.state.FsaPermissions[PensionTransfersFsaRegulatedActivityId];
            if (permission && isArray(permission) && permission.some(y => y.FsaInvestmentType?.Name == "PensionTransfers" && y.IsPermit == true)
                && permission.some(y => y.FsaInvestmentType?.Name == "Unit" && y.IsPermit == true)
                && permission.some(y => y.FsaInvestmentType?.Name == "LifePolicy" && y.IsPermit == true)
                && permission.some(y => y.FsaInvestmentType?.Name == "PersonalPensionScheme" && y.IsPermit == true)) 
            {
                flag = true;
            }
        }
        return flag
    }

    render() {
        const { data, isReview} = this.props;
        const { FsaPermissions } = this.state;
        return (
            <>
                <div className="form-group">
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="FCA/Trading reference:"
                        disabled={isReview}
                        required={"Please enter FCA/Trading reference"}
                        value={data.FsaAuthorisationNumber}
                        maxLength={8}
                        regex={{ errorMessage: "Must be numeric values only", value: Numeric }}
                        onChange={(v) => {
                            this.props.onChange({ FsaAuthorisationNumber: v });
                        }}
                        tooltip={"If another firm has provided the pension transfer advice, please provide their details below"}
                    />
                    <Button
                        className={`btn primary ${this.state.IsFindCompanyBusy ? "is-busy" : ""}`}
                        onClick={() => {
                            if (!data.FsaAuthorisationNumber) {
                                this.props.showErrorMsgPopUp(["Please enter FCA/Trading reference"], true);
                            }
                            else {
                                this.GetSourcedCompanyDetails();
                            }
                        }}
                    >
                        Find
                    </Button>
                </div>
                {this.state.NoMatchFound && (
                    <Alert
                        alertType={AlertType.Error}
                        message={"Unable to process application at this time due to insufficient FCA permissions."}
                    />
                )}
                { this.state.NoMatchFound==false && (this.state.FsaSourcedCompanyDetailModel?.Status != FsaAuthorisationStatus.Authorised || !this.IsPensionTransfersPermissionHeld()) &&
                    (
                        <Alert
                            alertType={AlertType.Warning}
                            message={"Unable to process application at this time due to insufficient FCA permissions. (FCA permission not authorised or pension transfer permission not held)"}
                        />
                    )
                }

                { this.state.NoMatchFound==false && this.state.FsaSourcedCompanyDetailModel?.Status == FsaAuthorisationStatus.Authorised && this.IsPensionTransfersPermissionHeld() &&
                    (
                        <Alert
                            alertType={AlertType.Success}
                            message={"FCA Pension transfer permissions are held and Authorisation status is Authorised"}
                        />
                    )
                }
            </>
        );
    }
}
